import { createFileRoute } from '@tanstack/react-router';
import { AccountsPage } from '../../../components/portals/accounts/AccountsPage';

export const Route = createFileRoute('/portal/managers/accounts')({
  component: AccountsPage,
});
